import React from 'react';
import Carousel from '@/common/Carousel/Carousel';
import useCarouselSettings from '~/hooks/common/ui/useCarouselSettings';

const MAX_LENGTH = 4;

type OwnProps = {
  includeHeading?: boolean;
  includeSubHeader?: boolean;
  Tile: React.FC;
};

export default function CarouselSkeleton({
  includeHeading = false,
  includeSubHeader = false,
  Tile
}: OwnProps) {
  const { values, carouselRef } = useCarouselSettings({
    heading: includeHeading ? 'header' : '',
    subHeading: includeSubHeader ? 'sub header' : '',
    maxLength: MAX_LENGTH,
    isSkeleton: true
  });

  const skeletons = new Array(MAX_LENGTH)
    .fill('')
    .map((_, idx) => <Tile key={idx} />);

  return (
    <Carousel {...values} ref={carouselRef} isSkeleton>
      {skeletons}
    </Carousel>
  );
}
